(function () {
  'use strict';

  // ─── Price lookup extracted from Globo CSV export ───
  // Format per entry: [shopifyVariantId, priceINR]
  var GL = {
    goldPurity: {
      '18KT': [51135742148899, 39284],
      '14KT': [51135742181667, 27521]
    },
    // 0.5ct / 0.7ct use grouped DE/FG colors with a single VVS/VS clarity tier
    // 1ct+ use individual D-H colors × VVS1/VVS2/VS1/VS2
    diamonds: {
      '0.5': { grouped: true, v: {
        'DE': {'VVS/VS': [48759438016803, 19776]},
        'FG': {'VVS/VS': [48759438049571, 18540]}
      }},
      '0.7': { grouped: true, v: {
        'DE': {'VVS/VS': [48759438573859, 28840]},
        'FG': {'VVS/VS': [48759438606627, 27192]}
      }},
      '1': { grouped: false, v: {
        'D': {'VVS1':[48707610345763,67980],'VVS2':[48707610378531,63448],'VS1':[48707610411299,61182],'VS2':[48707610444067,60049]},
        'E': {'VVS1':[48707610476835,61600],'VVS2':[48707610509603,59400],'VS1':[48707610542371,58300],'VS2':[48707610575139,57200]},
        'F': {'VVS1':[48707610607907,59400],'VVS2':[48707610640675,58300],'VS1':[48707610673443,57200],'VS2':[48707610706211,55000]},
        'G': {'VVS1':[48707610738979,57200],'VVS2':[48707610771747,55000],'VS1':[48707610804515,49500],'VS2':[48707610837283,44000]},
        'H': {'VVS1':[48707610870051,55000],'VVS2':[48707610902819,49500],'VS1':[48707610935587,44000],'VS2':[48707610968355,41800]}
      }},
      '1.5': { grouped: false, v: {
        'D': {'VVS1':[48751852421411,103773],'VVS2':[48751852454179,97387],'VS1':[48751852486947,94194],'VS2':[48751852519715,92597]},
        'E': {'VVS1':[48751852552483,97387],'VVS2':[48751852585251,94194],'VS1':[48751852618019,92597],'VS2':[48751852650787,91001]},
        'F': {'VVS1':[48751852683555,94194],'VVS2':[48751852716323,92597],'VS1':[48751852749091,91001],'VS2':[48751852781859,87808]},
        'G': {'VVS1':[48751852814627,91001],'VVS2':[48751852847395,87808],'VS1':[48751852880163,79825],'VS2':[48751852912931,71843]},
        'H': {'VVS1':[48751852945699,87808],'VVS2':[48751852978467,79825],'VS1':[48751853011235,71843],'VS2':[48751853044003,68650]}
      }},
      '2': { grouped: false, v: {
        'D': {'VVS1':[48759438704931,147805],'VVS2':[48759438737699,139359],'VS1':[48759438770467,135136],'VS2':[48759438803235,133025]},
        'E': {'VVS1':[48759438836003,139359],'VVS2':[48759438868771,135136],'VS1':[48759438901539,133025],'VS2':[48759438934307,130913]},
        'F': {'VVS1':[48759438967075,135136],'VVS2':[48759438999843,133025],'VS1':[48759439032611,130913],'VS2':[48759439065379,126690]},
        'G': {'VVS1':[48759439098147,130913],'VVS2':[48759439130915,126690],'VS1':[48759439163683,116133],'VS2':[48759439196451,105575]},
        'H': {'VVS1':[48759439229219,126690],'VVS2':[48759439261987,116133],'VS1':[48759439294755,105575],'VS2':[48759439327523,101352]}
      }},
      '2.5': { grouped: false, v: {
        'D': {'VVS1':[48759439360291,183855],'VVS2':[48759439393059,173349],'VS1':[48759439425827,168096],'VS2':[48759439458595,165470]},
        'E': {'VVS1':[48759439491363,173349],'VVS2':[48759439524131,168096],'VS1':[48759439556899,165470],'VS2':[48759439589667,162843]},
        'F': {'VVS1':[48759439687971,165470],'VVS2':[48759439655203,162843],'VS1':[48759439687971,162843],'VS2':[48759439720739,157590]},
        'G': {'VVS1':[48759439753507,162843],'VVS2':[48759439786275,157590],'VS1':[48759439819043,144458],'VS2':[48759439851811,131325]},
        'H': {'VVS1':[48759439884579,157590],'VVS2':[48759439917347,144458],'VS1':[48759439950115,131325],'VS2':[48759439982883,126072]}
      }},
      '3': { grouped: false, v: {
        'D': {'VVS1':[48759440048419,251320],'VVS2':[48759440081187,238754],'VS1':[48759440113955,232471],'VS2':[48759440146723,229330]},
        'E': {'VVS1':[48759440179491,238754],'VVS2':[48759440212259,232471],'VS1':[48759440245027,229330],'VS2':[48759440277795,226188]},
        'F': {'VVS1':[48759440310563,232471],'VVS2':[48759440343331,229330],'VS1':[48759440376099,226188],'VS2':[48759440408867,219905]},
        'G': {'VVS1':[48759440441635,226188],'VVS2':[48759440474403,219905],'VS1':[48759440507171,204198],'VS2':[48759440539939,188490]},
        'H': {'VVS1':[48759440572707,219905],'VVS2':[48759440605475,204198],'VS1':[48759440638243,188490],'VS2':[48759440671011,182207]}
      }},
      '3.5': { grouped: false, v: {
        'D': {'VVS1':[48862835966243,292520],'VVS2':[48862835999011,277894],'VS1':[48862836031779,270581],'VS2':[48862836064547,266925]},
        'E': {'VVS1':[48862836097315,277894],'VVS2':[48862836130083,270581],'VS1':[48862836162851,266925],'VS2':[48862836195619,263268]},
        'F': {'VVS1':[48862836228387,270581],'VVS2':[48862836261155,266925],'VS1':[48862836293923,263268],'VS2':[48862836326691,255955]},
        'G': {'VVS1':[48862836359459,263268],'VVS2':[48862836392227,255955],'VS1':[48862836424995,237673],'VS2':[48862836457763,219390]},
        'H': {'VVS1':[48862836490531,255955],'VVS2':[48862836523299,237673],'VS1':[48862836556067,219390],'VS2':[48862836588835,212077]}
      }},
      '4': { grouped: false, v: {
        'D': {'VVS1':[48759440703779,354578],'VVS2':[48759440736547,337892],'VS1':[48759440769315,329549],'VS2':[48759440802083,325377]},
        'E': {'VVS1':[48759440834851,337892],'VVS2':[48759440867619,329549],'VS1':[48759440900387,325377],'VS2':[48759440933155,321206]},
        'F': {'VVS1':[48759440965923,329549],'VVS2':[48759440998691,325377],'VS1':[48759441031459,321206],'VS2':[48759441064227,312863]},
        'G': {'VVS1':[48759441096995,321206],'VVS2':[48759441129763,312863],'VS1':[48759441162531,292005],'VS2':[48759441195299,271148]},
        'H': {'VVS1':[48759441228067,312863],'VVS2':[48759441260835,292005],'VS1':[48759441293603,271148],'VS2':[48759441326371,262805]}
      }},
      '4.5': { grouped: false, v: {
        'D': {'VVS1':[48862836687139,398353],'VVS2':[48862836719907,379607],'VS1':[48862836752675,370234],'VS2':[48862836785443,365547]},
        'E': {'VVS1':[48862836818211,379607],'VVS2':[48862836850979,370234],'VS1':[48862836883747,365547],'VS2':[48862836916515,360861]},
        'F': {'VVS1':[48862836949283,370234],'VVS2':[48862836982051,365547],'VS1':[48862837014819,360861],'VS2':[48862837047587,351488]},
        'G': {'VVS1':[48862837080355,360861],'VVS2':[48862837113123,351488],'VS1':[48862837145891,328055],'VS2':[48862837178659,304623]},
        'H': {'VVS1':[48862837211427,351488],'VVS2':[48862837244195,328055],'VS1':[48862837276963,304623],'VS2':[48862837309731,295250]}
      }},
      '5': { grouped: false, v: {
        'D': {'VVS1':[48759441424675,468135],'VVS2':[48759441457443,447329],'VS1':[48759441490211,436926],'VS2':[48759441522979,431725]},
        'E': {'VVS1':[48759441555747,447329],'VVS2':[48759441588515,436926],'VS1':[48759441621283,431725],'VS2':[48759441654051,426523]},
        'F': {'VVS1':[48759441686819,436926],'VVS2':[48759441719587,431725],'VS1':[48759441752355,426523],'VS2':[48759441785123,416120]},
        'G': {'VVS1':[48759441817891,426523],'VVS2':[48759441850659,416120],'VS1':[48759441883427,390113],'VS2':[48759441916195,364105]},
        'H': {'VVS1':[48759441948963,416120],'VVS2':[48759441981731,390113],'VS1':[48759442014499,364105],'VS2':[48759442047267,353702]}
      }}
    }
  };

  var state = {
    shape: null,
    metal: null,
    nativeVariantId: null,
    carat: '1',
    color: 'D',
    clarity: 'VVS1',
    purity: '18KT',
    purityVariantId: GL.goldPurity['18KT'][0],
    purityPrice: GL.goldPurity['18KT'][1],
    ringSize: '',
    engraving: '',
    diamondVariantId: null,
    diamondPrice: 0
  };

  // ─── Lookup diamond variant for current state ───
  function getDiamondEntry() {
    var d = GL.diamonds[state.carat];
    if (!d) return null;
    var colorKey, clarityKey;
    if (d.grouped) {
      colorKey = (state.color === 'D' || state.color === 'E') ? 'DE' : 'FG';
      clarityKey = 'VVS/VS';
    } else {
      colorKey = state.color;
      clarityKey = state.clarity;
    }
    return (d.v[colorKey] && d.v[colorKey][clarityKey]) ? d.v[colorKey][clarityKey] : null;
  }

  // ─── Match native Shopify variant from shape + metal selections ───
  function updateNativeVariant() {
    var variants = (window.theadoreProduct && window.theadoreProduct.variants) ? window.theadoreProduct.variants : [];
    if (!variants.length) return;
    var match = null;
    if (state.shape && state.metal) {
      match = variants.find(function(v) {
        return v.options && v.options[0] === state.shape && v.options[1] === state.metal;
      });
    }
    if (!match && state.shape) {
      match = variants.find(function(v) { return v.options && v.options[0] === state.shape; });
    }
    if (!match) match = variants[0];

    if (match) {
      state.nativeVariantId = match.id;
      // Swap gallery image to the variant's featured image
      if (window.rvGalleryFilter) window.rvGalleryFilter(match);
      var idx = window.rvGallerySlideIndex ? window.rvGallerySlideIndex(match)
        : (match.featured_image && match.featured_image.position ? match.featured_image.position - 1 : -1);
      if (idx > -1) {
        var slides = document.querySelectorAll('.gallery-slide');
        var thumbs = document.querySelectorAll('.gallery-thumb');
        if (slides[idx]) {
          slides.forEach(function(s) { s.classList.remove('active'); });
          thumbs.forEach(function(t) { t.classList.remove('active'); });
          slides[idx].classList.add('active');
          if (thumbs[idx]) thumbs[idx].classList.add('active');
        }
      }
    }
  }

  // ─── Update diamond variant from carat/color/clarity state ───
  function updateDiamondVariant() {
    var entry = getDiamondEntry();
    if (entry) {
      state.diamondVariantId = entry[0];
      state.diamondPrice = entry[1];
    } else {
      state.diamondVariantId = null;
      state.diamondPrice = 0;
    }
  }

  // ─── Recalculate and display total price ───
  function updatePrice() {
    var total = state.purityPrice + state.diamondPrice;
    if (state.engraving.length > 0) total += 500;
    var formatted = total > 0 ? formatINR(total) : '—';
    var priceEl = document.getElementById('rv-calc-price');
    if (priceEl) priceEl.textContent = formatted;
    var stickyPrice = document.getElementById('sticky-atc-price');
    if (stickyPrice) stickyPrice.textContent = formatted;
    var btn = document.getElementById('rv-add-to-cart');
    if (btn) {
      var ready = !!(state.nativeVariantId && state.diamondVariantId && state.purityVariantId);
      btn.disabled = !ready;
      btn.textContent = ready ? 'ADD TO CART' : 'Select all options';
    }
  }

  function formatINR(rupees) {
    return '₹' + Math.round(rupees).toLocaleString('en-IN');
  }

  // ─── Binders ───
  function bindShapes() {
    document.querySelectorAll('.rv-opt-shape').forEach(function(el) {
      el.addEventListener('click', function() {
        document.querySelectorAll('.rv-opt-shape').forEach(function(s) { s.classList.remove('rv-opt--active'); });
        el.classList.add('rv-opt--active');
        state.shape = el.dataset.value;
        var sel = document.getElementById('rv-shape-selected');
        if (sel) sel.textContent = state.shape;
        updateNativeVariant();
        updatePrice();
      });
    });
    var first = document.querySelector('.rv-opt-shape');
    if (first) first.click();
  }

  function bindMetals() {
    document.querySelectorAll('.rv-opt-metal').forEach(function(el) {
      el.addEventListener('click', function() {
        document.querySelectorAll('.rv-opt-metal').forEach(function(m) { m.classList.remove('rv-opt--active'); });
        el.classList.add('rv-opt--active');
        state.metal = el.dataset.value;
        var sel = document.getElementById('rv-metal-selected');
        if (sel) sel.textContent = state.metal;
        updateNativeVariant();
        updatePrice();
      });
    });
    var firstMetal = document.querySelector('.rv-opt-metal');
    if (firstMetal) firstMetal.click();
  }

  function bindCarats() {
    document.querySelectorAll('.rv-opt-carat').forEach(function(el) {
      el.addEventListener('click', function() {
        document.querySelectorAll('.rv-opt-carat').forEach(function(c) { c.classList.remove('rv-opt--active'); });
        el.classList.add('rv-opt--active');
        state.carat = el.dataset.value;
        var sel = document.getElementById('rv-carat-selected');
        if (sel) sel.textContent = state.carat + ' ct';
        updateDiamondVariant();
        updatePrice();
      });
    });
    var defaultCarat = document.querySelector('.rv-opt-carat[data-value="1"]');
    if (defaultCarat) defaultCarat.click();
    else {
      var firstCarat = document.querySelector('.rv-opt-carat');
      if (firstCarat) firstCarat.click();
    }
  }

  function bindOptionGroup(groupName, stateKey) {
    document.querySelectorAll('[data-group="' + groupName + '"]').forEach(function(el) {
      el.addEventListener('click', function() {
        document.querySelectorAll('[data-group="' + groupName + '"]').forEach(function(b) { b.classList.remove('rv-opt--active'); });
        el.classList.add('rv-opt--active');
        state[stateKey] = el.dataset.value;
        updateDiamondVariant();
        updatePrice();
      });
    });
    var first = document.querySelector('[data-group="' + groupName + '"]');
    if (first) first.click();
  }

  function bindPurities() {
    document.querySelectorAll('[data-group="purity"]').forEach(function(el) {
      el.addEventListener('click', function() {
        document.querySelectorAll('[data-group="purity"]').forEach(function(b) { b.classList.remove('rv-opt--active'); });
        el.classList.add('rv-opt--active');
        state.purity = el.dataset.value;
        var entry = GL.goldPurity[state.purity];
        if (entry) {
          state.purityVariantId = entry[0];
          state.purityPrice = entry[1];
        }
        updatePrice();
      });
    });
    var def = document.querySelector('[data-group="purity"][data-value="18KT"]') || document.querySelector('[data-group="purity"]');
    if (def) def.click();
  }

  function bindRingSize() {
    var sel = document.getElementById('rv-ring-size');
    if (!sel) return;
    sel.addEventListener('change', function() { state.ringSize = sel.value; });
  }

  function bindEngraving() {
    var inp = document.getElementById('rv-engraving');
    var counter = document.getElementById('rv-engraving-count');
    if (!inp) return;
    inp.addEventListener('input', function() {
      state.engraving = inp.value.trim();
      if (counter) counter.textContent = inp.value.length + '/20';
      updatePrice();
    });
  }

  // ─── Build line-item properties for the main product ───
  function buildProperties() {
    var props = {};
    if (state.shape)     props['Diamond Shape']  = state.shape;
    if (state.carat)     props['Carat Weight']   = state.carat + ' ct';
    if (state.color)     props['Color Grade']    = state.color;
    if (state.clarity)   props['Clarity']        = state.clarity;
    if (state.metal)     props['Metal Color']    = state.metal;
    if (state.purity)    props['Gold Purity']    = state.purity;
    if (state.ringSize)  props['Ring Size']      = state.ringSize;
    if (state.engraving) props['Engraving']      = state.engraving;
    return props;
  }

  // ─── Add to Cart: main product + diamond add-on + gold purity add-on ───
  function handleAddToCart(e) {
    e.preventDefault();
    if (!state.nativeVariantId) { alert('Please select a diamond shape.'); return; }
    if (!state.diamondVariantId) { alert('Please complete diamond options (carat / color / clarity).'); return; }
    if (!state.purityVariantId)  { alert('Please select gold purity.'); return; }

    var btn = document.getElementById('rv-add-to-cart');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    // One id shared by all three lines so the ring + its diamond/gold add-ons
    // are treated as ONE locked bundle in the cart (can't be split apart or
    // removed individually -> no zero-value checkout). Underscore-prefixed
    // props are hidden from the customer by Shopify.
    var bundleId = 'rv-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
    var mainProps = buildProperties();
    mainProps['_bundle'] = bundleId;

    var payload = {
      items: [
        {
          id: state.nativeVariantId,
          quantity: 1,
          properties: mainProps
        },
        {
          id: state.diamondVariantId,
          quantity: 1,
          properties: {
            '_type': 'diamond_addon',
            '_bundle': bundleId,
            '_for': state.shape + ' / ' + state.carat + 'ct ' + state.color + '/' + state.clarity
          }
        },
        {
          id: state.purityVariantId,
          quantity: 1,
          properties: {
            '_type': 'gold_setting_addon',
            '_bundle': bundleId,
            '_purity': state.purity
          }
        }
      ]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status) {
        alert('Error: ' + (data.description || 'Could not add to cart.'));
        if (btn) { btn.disabled = false; btn.textContent = 'ADD TO CART'; }
      } else {
        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        } else {
          window.location.href = '/cart';
        }
      }
    })
    .catch(function() {
      alert('Something went wrong. Please try again.');
      if (btn) { btn.disabled = false; btn.textContent = 'ADD TO CART'; }
    });
  }

  // ─── Boot ───
  document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('rv-options-form');
    if (!form) return;
    bindShapes();
    bindMetals();
    bindCarats();
    bindOptionGroup('color', 'color');
    bindOptionGroup('clarity', 'clarity');
    bindPurities();
    bindRingSize();
    bindEngraving();
    updateNativeVariant();
    updateDiamondVariant();
    updatePrice();
    form.addEventListener('submit', handleAddToCart);
  });

})();
